import { render, staticRenderFns } from "./ResumeClinic.vue?vue&type=template&id=4b39a5ae"
import script from "./ResumeClinic.vue?vue&type=script&lang=js"
export * from "./ResumeClinic.vue?vue&type=script&lang=js"
import style0 from "./ResumeClinic.vue?vue&type=style&index=0&id=4b39a5ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports